export class Tournament {
    $key?: string;
    cid: string;
    clubName?: string;
    cId: string;
    course: string;
    endDate: string;
    startDate: string;
    eventName: string;
    holesCount: number;
    date: string;
    holesPart: number;
    image: string;
    info: string;
    isClosed: boolean;
    leaderboard: any;
    proAm: boolean;
    teamPlay: number;
    tee: string;
    type: number;
    code?: number;
    playerPerTeam?: number;
    isFixtureShow?: boolean;
    status: string;
    startDateString?: string;

}
